import { IMongooseDocument } from "../types/mongoose";

export const getId = (id: string | IMongooseDocument) => {
    if (!id) return null;
    if (typeof id === "string") return id;
    return id._id;
}